<template>
    <div id="excel-solicitud-obra">
      <v-list-item
      @click="generarExcelSolicitud" link>
        <v-list-item-icon>
          <v-icon> mdi-file-excel </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> Excel Solicitud </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </div>
</template>
<script>
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
// Fila en la que inician los datos con titulos del excel
const filaTitulos = 1;
// const filaSubtitulos = filaTitulos + 1;

export default {
  name: 'ExcelSolicitudObra',
  mixins: [mixGenerarExceles],

  props: {
    solicitudObra: {
      type: Object,
      required: true,
    },
    firma: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      estaCargando: false,
      nombreDocumento: 'SOLICITUD DE OBRA',
      // Configuraciones para cada sheet
      configuracionSheets: {
        solicitud1: {
          estilosTablas: [],
          anchoColumnas: [
            { columna: 1, size: 6 },
            { columna: 2, size: 40 },
            { columna: 5, size: 9 },
            { columna: 6, size: 6 },
            { columna: 9, size: 5 },
          ],
          altoFilas: [
            { fila: 8, size: 10 },
            { fila: 9, size: 10 },
            { fila: 10, size: 10 },
            { fila: 17, size: 50 },

          ],
        },
        solicitud2: {
          estilosTablas: [],
          anchoColumnas: [
            { columna: 1, size: 6 },
          ],
          altoFilas: [
            { fila: 8, size: 25 },
            { fila: 9, size: 25 },
            { fila: 11, size: 80 },
            { fila: 17, size: 50 },
          ],
        },
        cedulaBasica: {
          estilosTablas: [],
          anchoColumnas: [
            { columna: 1, to: 8, size: 17 },
          ],
          altoFilas: [
            { fila: 15, size: 38 },
            { fila: 60, size: 80 },
            { fila: 63, size: 80 },
          ],
        },
        cedula2: {
          estilosTablas: [],
          anchoColumnas: [],
          altoFilas: [
            { fila: 7, size: 60 },
            { fila: 10, size: 27 },
            { fila: 39, size: 27 },
          ],
        },
        ubicacion: {
          estilosTablas: [],
          anchoColumnas: [],
          altoFilas: [
            { fila: 7, size: 60 },
            { fila: 10, size: 27 },
            { fila: 39, size: 27 },
          ],
        },
        cuestionario: {
          estilosTablas: [],
          anchoColumnas: [],
          altoFilas: [
            { fila: 8, size: 60 },
            { fila: 10, size: 27 },
            { fila: 14, size: 27 },
            { fila: 16, size: 90 },
            { fila: 20, size: 27 },
            { fila: 24, size: 27 },
            { fila: 28, size: 27 },
          ],
        },
      },
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
          wrapText: true,
        },
      },
      headersColumnas: [
        {
          value: '', nombreColumna: 'dato', orden: 1,
        },
      ],
      noData: [{
        dato: '',
      }],
      estilos: {
        centrado: {
          alignment: {
            horizontal: 'center',
            vertical: 'center',
          },
        },
        dinero: {
          numberFormat: '$#,##0.00',
        },
        relleno: {
          fill: {
            type: 'pattern', patternType: 'solid', bgColor: '#B3B3B3', fgColor: '#B3B3B3',
          },
        },
        todosLosBordes: {
          border: {
            top: {
              style: 'medium',
              color: '000000',
            },
            bottom: {
              style: 'medium',
              color: '000000',
            },
            left: {
              style: 'medium',
              color: '000000',
            },
            right: {
              style: 'medium',
              color: '000000',
            },
          },
        },
        todosLosBordesThin: {
          border: {
            top: {
              style: 'thin',
              color: '000000',
            },
            bottom: {
              style: 'thin',
              color: '000000',
            },
            left: {
              style: 'thin',
              color: '000000',
            },
            right: {
              style: 'thin',
              color: '000000',
            },
          },
        },
      },
    };
  },
  methods: {
    setBordesLaterales(datos) {
      // datos debe contener la fila de inicio, fin y cuantas columnas conforman el ancho del excel
      // ejemplo :
      // const datos = { filaInicio: 1, filaFinal: 10, columnaInicio: 5, columnaFinal: 9 };
      const bordes = [];
      if (!datos
        || !datos.filaInicio
        || !datos.filaFinal
        || !datos.columnaInicio
        || !datos.columnaFinal) {
        return [];
      }
      for (let i = datos.filaInicio; i <= datos.filaFinal; i += 1) {
        bordes.push(
          {
            value: '',
            row: i,
            col: datos.columnaInicio,
            estilo: {
              border: {
                left: {
                  style: 'thin',
                  color: '000000',
                },
              },
            },
          },
          {
            value: '',
            row: i,
            col: datos.columnaFinal,
            estilo: {
              border: {
                right: {
                  style: 'thin',
                  color: '000000',
                },
              },
            },
          },
        );
      }
      return bordes;
    },
    async generarExcelSolicitud() {
      const data = await this.crearExcelSolicitudObra();
      await this.mixGenerarExcelMultiPagina(data);
    },
    async crearExcelSolicitudObra() {
      const datosDocumentoSolicitud1 = this.crearDatosDocumentoSolicitud1;
      const datosDocumentoSolicitud2 = this.crearDatosDocumentoSolicitud2;
      const datosDocumentoCedulaBasica = this.crearDatosDocumentoCedulaBasica;
      const datosDocumentoCedula2 = this.crearDatosDocumentoCedula2;
      const datosDocumentoCuestionario = this.crearDatosDocumentoCuestionario;
      const datosDocumentoUbicacion = this.crearDatosDocumentoUbicacion;
      const photosUbicacion = await this.setFotosUbicacion();
      const dataHeaders = this.getHeaders;
      const data = {
        excelData: {
          sheets: [
            {
              nombre: 'SOLICITUD1',
              configuracion: this.configuracionSheets.solicitud1,
              header: {
                filaInicio: filaTitulos,
                estilo: this.estiloHeader,
                datosDocumento: [...datosDocumentoSolicitud1],
                data: [...dataHeaders],
              },
            },
            {
              nombre: 'SOLICITUD2',
              configuracion: this.configuracionSheets.solicitud2,
              header: {
                filaInicio: filaTitulos,
                estilo: this.estiloHeader,
                datosDocumento: [...datosDocumentoSolicitud2],
                data: [...dataHeaders],
              },
            },
            {
              nombre: 'CEDULA BASICA',
              configuracion: this.configuracionSheets.cedulaBasica,
              header: {
                filaInicio: filaTitulos,
                estilo: this.estiloHeader,
                datosDocumento: [...datosDocumentoCedulaBasica],
                data: [...dataHeaders],
              },
            },
            {
              nombre: 'CEDULA 2',
              configuracion: this.configuracionSheets.cedula2,
              header: {
                filaInicio: filaTitulos,
                estilo: this.estiloHeader,
                datosDocumento: [...datosDocumentoCedula2],
                data: [...dataHeaders],
              },
            },
            {
              nombre: 'UBICACION',
              configuracion: this.configuracionSheets.ubicacion,
              header: {
                filaInicio: filaTitulos,
                estilo: this.estiloHeader,
                datosDocumento: [...datosDocumentoUbicacion],
                photos: photosUbicacion,
                data: [...dataHeaders],
              },
            },
            {
              nombre: 'CUEST',
              configuracion: this.configuracionSheets.cuestionario,
              header: {
                filaInicio: filaTitulos,
                estilo: this.estiloHeader,
                datosDocumento: [...datosDocumentoCuestionario],
                data: [...dataHeaders],
              },
            },
          ],
        },
      };
      return data;
    },
    async setFotosUbicacion() {
      const { imagenMacrolocalizacion, imagenMicrolocalizacion } = this.solicitudObra;
      if (!imagenMacrolocalizacion && !imagenMicrolocalizacion) return null;
      const publicKeys = [imagenMacrolocalizacion, imagenMicrolocalizacion];
      const BASE_URL = process.env.NODE_ENV !== 'production'
        ? 'http://localhost:3001'
        : 'https://sideop-file-server.hermosillo.gob.mx';
      const imagenes = await this.axios({
        method: 'POST',
        url: `${BASE_URL}/files`,
        responseType: 'json',
        data: {
          publicKeys,
        },
      })
        .then((res) => res.data)
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
      const imagenMacro = imagenes.find((imagen) => imagen.name.includes('macrolocalizacion')) || null;
      const imagenMicro = imagenes.find((imagen) => imagen.name.includes('microlocalizacion')) || null;

      const photos = [];
      if (imagenMacro) {
        photos.push({
          path: `Solicitudes Obras/imagenes/${imagenMacro.name}`,
          type: 'picture',
          extension: `${imagenMacro.extension}`,
          position: {
            type: 'twoCellAnchor',
            from: {
              col: 1, colOff: 0, row: 11, rowOff: 0,
            },
            to: {
              col: 10, colOff: 0, row: 39, rowOff: 0,
            },
          },
        });
      }
      if (imagenMicro) {
        photos.push({
          path: `Solicitudes Obras/imagenes/${imagenMicro.name}`,
          type: 'picture',
          extension: `${imagenMicro.extension}`,
          position: {
            type: 'twoCellAnchor',
            from: {
              col: 1, colOff: 0, row: 40, rowOff: 0,
            },
            to: {
              col: 10, colOff: 0, row: 68, rowOff: 0,
            },
          },
        });
      }

      return photos;
    },
  },
  computed: {
    getYearSolicitud() {
      const { fechaMemorandum } = this.solicitudObra;
      return this.$moment(fechaMemorandum).format('YYYY');
    },
    getCalendarioAvanceFinanciero() {
      const calendarioAvanceFinanciero = JSON.parse(this.solicitudObra.calendario);
      return calendarioAvanceFinanciero.sort((a, b) => (`${a.mes}`).localeCompare(b.mes));
    },
    crearDatosDocumentoSolicitud1() {
      return [
      // INICIO INFORMACION ENCABEZADO DE PAGINA
        {
          value: 'DIRECCIÓN DE ESTUDIOS FINANCIEROS Y APOYOS ADMINISTRATIVOS',
          row: 2,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 2,
            col: 18,
          },
        },
        {
          value: 'HOJA 1 DE 2',
          row: 2,
          col: 19,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },

        },
        {
          value: `ANEXO TÉCNICO DE SOLICITUD ${this.getYearSolicitud}`,
          row: 3,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 3,
            col: 18,
          },
        },
        {
          value: `FUENTE FINANCIERA: ${this.solicitudObra.fuenteFinanciera.nombre}`,
          row: 5,
          col: 1,
          estilo: {
            font: {
              size: 9,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: `MEMORÁNDUM DE SOLICITUD No. ${this.solicitudObra.numeroMemorandum}`,
          row: 5,
          col: 13,
          estilo: {
            font: {
              size: 9,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: 'FECHA:',
          row: 6,
          col: 12,
          estilo: {
            font: {
              size: 9,
              bold: true,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.fechaMemorandum,
          row: 6,
          col: 13,
          estilo: {
            font: {
              size: 9,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: 'DEP. EJECUTORA :  COORDINACIÓN GENERAL DE INFRAESTRUCTURA, DESARROLLO URBANO Y ECOLOGÍA',
          row: 7,
          col: 1,
          estilo: {
            font: {
              size: 9,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        // FIN INFORMACION ENCABEZADO DE PAGINA

        // INICIO ENCABEZADOS TABLA
        {
          value: '',
          row: 8,
          col: 1,
          estilo: {
            font: {
              size: 7,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              top: {
                style: 'thin',
                color: '000000',
              },
              left: {
                style: 'thin',
                color: '000000',
              },
            },
            ...this.estilos.relleno,
          },
        },
        {
          value: '',
          row: 9,
          col: 1,
          estilo: {
            font: {
              size: 7,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
            },
            ...this.estilos.relleno,
          },
        },
        {
          value: '',
          row: 10,
          col: 1,
          estilo: {
            font: {
              size: 7,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
              left: {
                style: 'thin',
                color: '000000',
              },
            },
            ...this.estilos.relleno,
          },
        },
        {
          value: 'MODALIDAD',
          row: 8,
          col: 2,
          estilo: {
            font: {
              size: 7,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              top: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
            },
            ...this.estilos.relleno,
          },
        },
        {
          value: 'SUBMODALIDAD',
          row: 9,
          col: 2,
          estilo: {
            font: {
              size: 7,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              right: {
                style: 'thin',
                color: '000000',
              },
            },
            ...this.estilos.relleno,
          },
        },
        {
          value: 'OBRA',
          row: 10,
          col: 2,
          estilo: {
            font: {
              size: 7,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
            },
            ...this.estilos.relleno,
          },
        },
        {
          value: 'No.',
          row: 11,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 1,
          },
        },
        {
          value: 'DENOMINACIÓN',
          row: 11,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 2,
          },
        },
        {
          value: 'MUNICIPIO',
          row: 8,
          col: 3,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 3,
          },
        },
        {
          value: 'LOCALIDAD',
          row: 8,
          col: 4,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 4,
          },
        },
        {
          value: 'FECHA DE INICIO Y TERMINO',
          row: 8,
          col: 5,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 5,
          },
        },
        {
          value: 'MOD. DE EJEC.',
          row: 8,
          col: 6,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 6,
          },
        },
        {
          value: 'PESOS',
          row: 8,
          col: 7,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 10,
            col: 8,
          },
        },
        {
          value: 'COSTO',
          row: 11,
          col: 7,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 7,
          },
        },
        {
          value: 'INV. APL.',
          row: 11,
          col: 8,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 8,
          },
        },
        {
          value: 'AV. FIS. FEB',
          row: 8,
          col: 9,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 9,
          },
        },
        {
          value: `ESTRUCTURA FINANCIERA ${this.getYearSolicitud} (PESOS)`,
          row: 8,
          col: 10,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 10,
            col: 13,
          },
        },
        {
          value: 'TOTAL',
          row: 11,
          col: 10,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 10,
          },
        },
        {
          value: 'ESTATAL',
          row: 11,
          col: 11,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 11,
          },
        },
        {
          value: 'FEDERALIZADO',
          row: 11,
          col: 12,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 12,
          },
        },
        {
          value: 'MUNICIPAL',
          row: 11,
          col: 13,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 13,
          },
        },
        {
          value: 'METAS TOTALES',
          row: 8,
          col: 14,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 10,
            col: 17,
          },
        },
        {
          value: 'DEL PROYECTO',
          row: 11,
          col: 14,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 11,
            col: 15,
          },
        },
        {
          value: 'U.M.',
          row: 12,
          col: 14,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
        },
        {
          value: 'CANT.',
          row: 12,
          col: 15,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
        },
        {
          value: 'BENEFICIARIOS',
          row: 11,
          col: 16,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 11,
            col: 17,
          },
        },
        {
          value: 'U.M.',
          row: 12,
          col: 16,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
        },
        {
          value: 'CANT.',
          row: 12,
          col: 17,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
        },
        {
          value: `AV. FÍSICO AL 31/12/${this.getYearSolicitud}`,
          row: 8,
          col: 18,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 10,
            col: 19,
          },
        },
        {
          value: 'AÑO',
          row: 11,
          col: 18,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 18,
          },
        },
        {
          value: 'ACUM.',
          row: 11,
          col: 19,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.relleno,
          },
          combinar: {
            row: 12,
            col: 19,
          },
        },
        // FIN ENCABEZADOS TABLA
        // INICIO DATOS TABLA
        {
          value: '1',
          row: 13,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: this.solicitudObra.meta,
          row: 13,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: this.solicitudObra.municipio.nombre.toUpperCase(),
          row: 13,
          col: 3,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: this.solicitudObra.localidad,
          row: 13,
          col: 4,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: `${this.$moment(this.solicitudObra.fechaInicioObra).format('DD/MM/YYYY')} A ${this.$moment(this.solicitudObra.fechaTerminoObra).format('DD/MM/YYYY')}`,
          row: 13,
          col: 5,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: this.solicitudObra.modalidadEjecucion,
          row: 13,
          col: 6,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: this.solicitudObra.montoSolicitado,
          row: 13,
          col: 7,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: '100%',
          row: 13,
          col: 8,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: `${this.solicitudObra.avanceFisicoEnero}%`,
          row: 13,
          col: 9,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: this.solicitudObra.montoSolicitado,
          row: 13,
          col: 10,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoEstatal,
          row: 13,
          col: 11,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoFederal,
          row: 13,
          col: 12,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoMunicipal,
          row: 13,
          col: 13,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.unidadMetaFisica,
          row: 13,
          col: 14,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: this.solicitudObra.metaFisica,
          row: 13,
          col: 15,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: this.solicitudObra.beneficiariosTipo,
          row: 13,
          col: 16,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: this.solicitudObra.beneficiariosCantidad,
          row: 13,
          col: 17,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: `${this.solicitudObra.avanceFisicoDiciembre}%`,
          row: 13,
          col: 18,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: `${this.solicitudObra.avanceFisicoDiciembre}%`,
          row: 13,
          col: 19,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: 'SUBTOTAL CON IVA HOJA 1:',
          row: 14,
          col: 7,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 14,
            col: 8,
          },
        },
        {
          value: this.solicitudObra.montoSolicitado,
          row: 14,
          col: 10,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoEstatal,
          row: 14,
          col: 11,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoFederal,
          row: 14,
          col: 12,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoMunicipal,
          row: 14,
          col: 13,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.dinero,
          },
        },
        {
          value: 'SUBTOTAL ACUMULADO',
          row: 16,
          col: 7,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 16,
            col: 8,
          },
        },
        {
          value: this.solicitudObra.montoSolicitado,
          row: 16,
          col: 10,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoEstatal,
          row: 16,
          col: 11,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoFederal,
          row: 16,
          col: 12,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoMunicipal,
          row: 16,
          col: 13,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.dinero,
          },
        },
        // FIN DATOS TABLA

        // FIRMA
        {
          value: '',
          row: 17,
          col: 2,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: this.firma.funcionario?.nombre.toUpperCase(),
          row: 18,
          col: 1,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'top',
              wrapText: true,
            },
          },
          combinar: {
            row: 18,
            col: 3,
          },
        },
        {
          value: this.firma.funcionario?.puesto.toUpperCase(),
          row: 19,
          col: 1,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'top',
              wrapText: true,
            },
          },
          combinar: {
            row: 19,
            col: 3,
          },
        },
        {
          value: 'COORDINACIÓN GENERAL DE INFRAESTRUCTURA, DESARROLLO URBANO Y ECOLOGÍA',
          row: 20,
          col: 1,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 20,
            col: 3,
          },
        },
      ];
    },
    crearDatosDocumentoSolicitud2() {
      return [
        // INICIO INFORMACION ENCABEZADO DE PAGINA
        {
          value: 'DIRECCIÓN DE ESTUDIOS FINANCIEROS Y APOYOS ADMINISTRATIVOS',
          row: 2,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 2,
            col: 11,
          },
        },
        {
          value: 'HOJA 2 DE 2',
          row: 2,
          col: 12,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },

        },
        {
          value: `ANEXO TÉCNICO DE SOLICITUD ${this.getYearSolicitud}`,
          row: 3,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 3,
            col: 11,
          },
        },
        {
          value: `MEMORÁNDUM DE SOLICITUD No. ${this.solicitudObra.numeroMemorandum}`,
          row: 5,
          col: 12,
          estilo: {
            font: {
              size: 9,
              bold: true,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: 'FECHA:',
          row: 6,
          col: 11,
          estilo: {
            font: {
              size: 9,
              bold: true,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.fechaMemorandum,
          row: 6,
          col: 12,
          estilo: {
            font: {
              size: 9,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: 'DEP. EJECUTORA :  COORDINACIÓN GENERAL DE INFRAESTRUCTURA, DESARROLLO URBANO Y ECOLOGÍA',
          row: 7,
          col: 1,
          estilo: {
            font: {
              size: 9,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        // FIN INFORMACION ENCABEZADO DE PAGINA

        // INICIO ENCABEZADOS TABLA
        {
          value: 'No.',
          row: 8,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            ...this.estilos.relleno,
            ...this.estilos.todosLosBordes,
          },
          combinar: {
            row: 9,
            col: 1,
          },
        },
        {
          value: 'DESCRIPCION GENERAL DE LA OBRA',
          row: 8,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            ...this.estilos.relleno,
            ...this.estilos.todosLosBordes,
          },
          combinar: {
            row: 9,
            col: 6,
          },
        },
        {
          value: `CONCEPTOS A EJECUTAR EN ${this.getYearSolicitud}`,
          row: 8,
          col: 7,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            ...this.estilos.relleno,
            ...this.estilos.todosLosBordes,
          },
          combinar: {
            row: 9,
            col: 11,
          },
        },
        {
          value: 'COSTO',
          row: 8,
          col: 12,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            border: {
              top: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            ...this.estilos.relleno,
          },
        },
        {
          value: 'PESOS',
          row: 9,
          col: 12,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            ...this.estilos.relleno,
          },
        },

        // FIN ENCABEZADOS TABLA
        // INICIO DATOS TABLA
        {
          value: '',
          row: 10,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            ...this.estilos.todosLosBordesThin,
          },
        },
        {
          value: '',
          row: 10,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
          },
          combinar: {
            row: 10,
            col: 6,
          },
        },
        {
          value: '',
          row: 10,
          col: 7,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
          },
          combinar: {
            row: 10,
            col: 11,
          },
        },
        {
          value: '',
          row: 10,
          col: 12,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
          },
        },
        {
          value: '1',
          row: 11,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            ...this.estilos.todosLosBordesThin,
          },
        },
        {
          value: this.solicitudObra.meta,
          row: 11,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
          },
          combinar: {
            row: 11,
            col: 6,
          },
        },
        {
          value: this.solicitudObra.conceptosAEjecutar,
          row: 11,
          col: 7,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
          },
          combinar: {
            row: 11,
            col: 11,
          },
        },
        {
          value: this.solicitudObra.montoSolicitado,
          row: 11,
          col: 12,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
            ...this.estilos.dinero,
          },
        },
        {
          value: 'SUBTOTAL CON IVA',
          row: 13,
          col: 11,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.montoSolicitado,
          row: 13,
          col: 12,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: 'SUBTOTAL ACUMULADO',
          row: 15,
          col: 11,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.montoSolicitado,
          row: 15,
          col: 12,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.dinero,
          },
        },
        // FIN DATOS TABLA

        // FIRMA
        {
          value: '',
          row: 17,
          col: 2,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 17,
            col: 4,
          },
        },
        {
          value: this.firma.funcionario?.nombre.toUpperCase(),
          row: 18,
          col: 1,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'top',
              wrapText: true,
            },
          },
          combinar: {
            row: 18,
            col: 5,
          },
        },
        {
          value: this.firma.funcionario?.puesto.toUpperCase(),
          row: 19,
          col: 1,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'top',
              wrapText: true,
            },
          },
          combinar: {
            row: 19,
            col: 5,
          },
        },
        {
          value: 'COORDINACIÓN GENERAL DE INFRAESTRUCTURA, DESARROLLO URBANO Y ECOLOGÍA',
          row: 20,
          col: 1,
          estilo: {
            font: {
              size: 8,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 20,
            col: 5,
          },
        },
      ];
    },
    crearDatosDocumentoCedulaBasica() {
      const tablaAvanceFinanciero = [];
      for (let i = 0; i < this.getCalendarioAvanceFinanciero.length; i += 1) {
        tablaAvanceFinanciero.push(
          {
            value: this.getCalendarioAvanceFinanciero[i].mes,
            row: 68,
            col: i + 1,
            estilo: {
              font: {
                size: 10,
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
              border: {
                top: {
                  style: 'thin',
                  color: '000000',
                },
                bottom: {
                  style: 'thin',
                  color: '000000',
                },
                left: {
                  style: 'thin',
                  color: '000000',
                },
                right: {
                  style: 'thin',
                  color: '000000',
                },
              },
            },
          },
          {
            value: this.getCalendarioAvanceFinanciero[i].importe,
            row: 69,
            col: i + 1,
            estilo: {
              font: {
                size: 10,
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
              border: {
                top: {
                  style: 'thin',
                  color: '000000',
                },
                bottom: {
                  style: 'thin',
                  color: '000000',
                },
                left: {
                  style: 'thin',
                  color: '000000',
                },
                right: {
                  style: 'thin',
                  color: '000000',
                },
              },
              ...this.estilos.dinero,
            },
          },
          {
            value: `${this.getCalendarioAvanceFinanciero[i].avance}%`,
            row: 70,
            col: i + 1,
            estilo: {
              font: {
                size: 10,
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
              border: {
                top: {
                  style: 'thin',
                  color: '000000',
                },
                bottom: {
                  style: 'thin',
                  color: '000000',
                },
                left: {
                  style: 'thin',
                  color: '000000',
                },
                right: {
                  style: 'thin',
                  color: '000000',
                },
              },
            },
          },
          {
            value: `${this.getCalendarioAvanceFinanciero[i].avanceAcumulado}%`,
            row: 71,
            col: i + 1,
            estilo: {
              font: {
                size: 10,
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
              border: {
                top: {
                  style: 'thin',
                  color: '000000',
                },
                bottom: {
                  style: 'thin',
                  color: '000000',
                },
                left: {
                  style: 'thin',
                  color: '000000',
                },
                right: {
                  style: 'thin',
                  color: '000000',
                },
              },
            },
          },
        );
      }
      return [
        // INICIO INFORMACION ENCABEZADO DE PAGINA
        {
          value: `PROGRAMA DE INVERSIONES EJERCICIO ${this.getYearSolicitud}`,
          row: 2,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 2,
            col: 8,
          },
        },
        {
          value: 'EXPEDIENTE TÉCNICO SIMPLIFICADO',
          row: 3,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 3,
            col: 8,
          },
        },
        {
          value: 'ANEXO 1: CÉDULA DE INFORMACIÓN BÁSICA POR PROYECTO',
          row: 4,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 4,
            col: 8,
          },
        },
        {
          value: 'UBICACIÓN',
          row: 7,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 7,
            col: 8,
          },
        },
        ...this.setBordesLaterales({
          filaInicio: 8, filaFinal: 11, columnaInicio: 1, columnaFinal: 8,
        }),
        {
          value: 'MUNICIPIO',
          row: 8,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.municipio.nombre.toUpperCase(),
          row: 8,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 8,
            col: 3,
          },
        },
        {
          value: '',
          row: 8,
          col: 4,
          estilo: {
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: 'LOCALIDAD',
          row: 8,
          col: 5,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.localidad,
          row: 8,
          col: 6,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 8,
            col: 7,
          },
        },
        {
          value: '',
          row: 8,
          col: 8,
          estilo: {
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: 'BARRIO, COLONIA, RANCHERIA, ETC.',
          row: 9,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.colonia,
          row: 9,
          col: 4,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 9,
            col: 8,
          },
        },
        {
          value: 'CABECERA MUNICIPAL',
          row: 10,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: `SI ( ${this.solicitudObra.esCabecera ? 'X' : ''} )`,
          row: 10,
          col: 4,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
        },
        {
          value: `NO ( ${this.solicitudObra.esCabecera ? '' : 'X'} )`,
          row: 10,
          col: 6,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
        },
        {
          value: 'TIPO DE LOCALIDAD',
          row: 11,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: `COL. POPULAR ( ${this.solicitudObra.tipoLocalidad === 'COLONIA POPULAR' ? 'X' : ''} )`,
          row: 11,
          col: 3,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
        },
        {
          value: `POB. RURAL ( ${this.solicitudObra.tipoLocalidad === 'POBLACIÓN RURAL' ? 'X' : ''} )`,
          row: 11,
          col: 5,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
        },
        {
          value: `ZONA INDIGENA ( ${this.solicitudObra.tipoLocalidad === 'ZONA INDIGENA' ? 'X' : ''} )`,
          row: 11,
          col: 7,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
        },
        {
          value: '',
          row: 12,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            border: {
              top: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 12,
            col: 8,
          },
        },
        {
          value: 'IDENTIFICACIÓN',
          row: 13,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 13,
            col: 8,
          },
        },
        ...this.setBordesLaterales({
          filaInicio: 14, filaFinal: 20, columnaInicio: 1, columnaFinal: 8,
        }),
        {
          value: 'DEPENDENCIA O ENTIDAD EJECUTORA',
          row: 14,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: 'COORDINACIÓN GENERAL DE INFRAESTRUCTURA, DESARROLLO URBANO Y ECOLOGÍA',
          row: 14,
          col: 4,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 14,
            col: 8,
          },
        },
        {
          value: 'NOMBRE DE LA OBRA',
          row: 15,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: '1',
          row: 15,
          col: 2,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.meta,
          row: 15,
          col: 3,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 15,
            col: 8,
          },
        },
        {
          value: '',
          row: 16,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 16,
            col: 8,
          },
        },
        {
          value: 'TIPO DE PROYECTO',
          row: 17,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: `SOCIAL ( ${this.solicitudObra.tipoProyecto === 'SOCIAL' ? 'X' : ''} )`,
          row: 17,
          col: 4,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: `APOYO ( ${this.solicitudObra.tipoProyecto === 'APOYO' ? 'X' : ''} )`,
          row: 17,
          col: 5,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 17,
            col: 6,
          },
        },
        {
          value: `PRODUCTIVO ( ${this.solicitudObra.tipoProyecto === 'PRODUCTIVO' ? 'X' : ''} )`,
          row: 17,
          col: 7,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 17,
            col: 8,
          },
        },
        {
          value: 'TIPO DE OBRA',
          row: 18,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: `NUEVA ( ${this.solicitudObra.tipoObra === 'NUEVA' ? 'X' : ''} )`,
          row: 18,
          col: 4,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: `APLIACION ( ${this.solicitudObra.tipoObra === 'APLIACION' ? 'X' : ''} )`,
          row: 18,
          col: 5,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
        },
        {
          value: `REHABILITACION ( ${this.solicitudObra.tipoObra === 'REHABILITACION' ? 'X' : ''} )`,
          row: 18,
          col: 6,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 18,
            col: 7,
          },
        },
        {
          value: `PROCESO ( ${this.solicitudObra.tipoObra === 'PROCESO' ? 'X' : ''} )`,
          row: 18,
          col: 8,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
        },
        {
          value: 'MODALIDAD DE LA EJECUTCION',
          row: 19,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: `CONTRATO ( ${this.solicitudObra.modalidadEjecucion === 'CONTRATO' ? 'X' : ''} )`,
          row: 19,
          col: 4,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
        },
        {
          value: `ADMON. DIRECTA ( ${this.solicitudObra.modalidadEjecucion === 'ADMON. DIRECTA' ? 'X' : ''} )`,
          row: 19,
          col: 5,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 19,
            col: 6,
          },
        },
        {
          value: `MIXTA ( ${this.solicitudObra.modalidadEjecucion === 'MIXTA' ? 'X' : ''} )`,
          row: 19,
          col: 7,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 19,
            col: 8,
          },
        },
        {
          value: '',
          row: 21,
          col: 1,
          estilo: {
            border: {
              top: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 21,
            col: 8,
          },
        },
        {
          value: 'INVERSIÓN (pesos)',
          row: 22,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        ...this.setBordesLaterales({
          filaInicio: 24, filaFinal: 34, columnaInicio: 1, columnaFinal: 8,
        }),
        {
          value: 'CONCEPTO',
          row: 24,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              top: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 24,
            col: 3,
          },
        },
        {
          value: 'TOTAL',
          row: 24,
          col: 4,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            border: {
              top: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: 'ESTATAL',
          row: 24,
          col: 5,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            border: {
              top: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: 'FEDERAL',
          row: 24,
          col: 6,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            border: {
              top: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: 'MUNICIPAL',
          row: 24,
          col: 7,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            border: {
              top: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: 'OTROS',
          row: 24,
          col: 8,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            border: {
              top: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: 'COSTO TOTAL',
          row: 26,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.montoSolicitado,
          row: 26,
          col: 4,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoEstatal,
          row: 26,
          col: 5,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoFederal,
          row: 26,
          col: 6,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoMunicipal,
          row: 26,
          col: 7,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoOtros,
          row: 26,
          col: 8,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: 'INVERSIÓN APLICADA EN OTROS EJERCICOS',
          row: 28,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.montoInvertidoAnteriormente,
          row: 28,
          col: 4,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoInvertidoAnteriormenteEstatal,
          row: 28,
          col: 5,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoInvertidoAnteriormenteFederal,
          row: 28,
          col: 6,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoInvertidoAnteriormenteMunicipal,
          row: 28,
          col: 7,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoInvertidoAnteriormenteOtros,
          row: 28,
          col: 8,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: 'INVERSIÓN PARA EL AÑO',
          row: 32,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.montoSolicitado,
          row: 32,
          col: 4,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoEstatal,
          row: 32,
          col: 5,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoFederal,
          row: 32,
          col: 6,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoMunicipal,
          row: 32,
          col: 7,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: this.solicitudObra.montoSolicitadoOtros,
          row: 32,
          col: 8,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            ...this.estilos.dinero,
          },
        },
        {
          value: 'INVERSIÓN ADICIONAL REQUERIDA',
          row: 34,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: '',
          row: 35,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 35,
            col: 8,
          },
        },
        ...this.setBordesLaterales({
          filaInicio: 39, filaFinal: 47, columnaInicio: 1, columnaFinal: 8,
        }),
        {
          value: 'METAS PROGRAMADAS',
          row: 37,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: '',
          row: 38,
          col: 1,
          estilo: {
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 38,
            col: 8,
          },
        },
        {
          value: 'DEL PROYECTO TOTAL',
          row: 40,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.unidadMetaFisica,
          row: 41,
          col: 3,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combianr: {
            row: 41,
            col: 4,
          },
        },
        {
          value: 'CANTIDAD',
          row: 41,
          col: 6,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.metaFisica,
          row: 41,
          col: 7,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: `PARA EL ${this.getYearSolicitud}`,
          row: 44,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.unidadMetaFisica,
          row: 45,
          col: 3,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combianr: {
            row: 45,
            col: 4,
          },
        },
        {
          value: 'CANTIDAD',
          row: 45,
          col: 6,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: this.solicitudObra.metaFisica,
          row: 45,
          col: 7,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: '',
          row: 47,
          col: 1,
          estilo: {
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 47,
            col: 8,
          },
        },
        {
          value: 'FECHAS',
          row: 48,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        ...this.setBordesLaterales({
          filaInicio: 50, filaFinal: 55, columnaInicio: 1, columnaFinal: 8,
        }),
        {
          value: '',
          row: 49,
          col: 1,
          estilo: {
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 49,
            col: 8,
          },
        },
        {
          value: 'DEL PROYECTO TOTAL:',
          row: 50,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: 'INICIO:',
          row: 50,
          col: 3,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: this.$moment(this.solicitudObra.fechaInicioObra).format('MMMM. [DEL] YYYY').toUpperCase(),
          row: 50,
          col: 4,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: 'TERMINACIÓN:',
          row: 50,
          col: 5,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: this.$moment(this.solicitudObra.fechaTerminoObra).format('MMMM. [DEL] YYYY').toUpperCase(),
          row: 50,
          col: 6,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: '(MES Y AÑO)',
          row: 51,
          col: 7,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
        },
        {
          value: 'DE LA INVERSIÓN DEL AÑO: ',
          row: 53,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: 'INICIO:',
          row: 53,
          col: 3,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: this.$moment(this.solicitudObra.fechaInicioObra).format('MMMM. [DEL] YYYY').toUpperCase(),
          row: 53,
          col: 4,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: 'TERMINACIÓN:',
          row: 53,
          col: 5,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: this.$moment(this.solicitudObra.fechaTerminoObra).format('MMMM. [DEL] YYYY').toUpperCase(),
          row: 53,
          col: 6,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: '(MES Y AÑO)',
          row: 54,
          col: 7,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
        },
        {
          value: '',
          row: 55,
          col: 1,
          estilo: {
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 55,
            col: 8,
          },
        },
        {
          value: 'DESCRIPCIÓN',
          row: 56,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        ...this.setBordesLaterales({
          filaInicio: 58, filaFinal: 64, columnaInicio: 1, columnaFinal: 8,
        }),
        {
          value: '',
          row: 57,
          col: 1,
          estilo: {
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 57,
            col: 8,
          },
        },
        {
          value: 'DE LA TOTALIDAD DE LA OBRA: ',
          row: 59,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 59,
            col: 3,
          },
        },
        {
          value: this.solicitudObra.meta,
          row: 60,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              right: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 60,
            col: 8,
          },
        },
        {
          value: 'CONCEPTOS A EJECUTAR DEL AÑO: ',
          row: 62,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 62,
            col: 3,
          },
        },
        {
          value: this.solicitudObra.conceptosAEjecutar,
          row: 63,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              right: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 63,
            col: 8,
          },
        },
        {
          value: '',
          row: 64,
          col: 1,
          estilo: {
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 64,
            col: 8,
          },
        },
        {
          value: 'AVANCE FINANCIERO',
          row: 66,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        // TABLA AVANCES FINACIEROS AQUI
        ...tablaAvanceFinanciero,
        {
          value: 'AVANCE FISICO',
          row: 75,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        ...this.setBordesLaterales({
          filaInicio: 77, filaFinal: 82, columnaInicio: 1, columnaFinal: 8,
        }),
        {
          value: '',
          row: 76,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 76,
            col: 8,
          },
        },
        {
          value: 'AVANCE FISICO ACTUAL',
          row: 78,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: `${this.solicitudObra.avanceFisicoEnero}%`,
          row: 78,
          col: 5,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: 'PROGRAMADO AL CIERRE DE EJERCICIO',
          row: 80,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
        },
        {
          value: `${this.solicitudObra.avanceFisicoDiciembre}%`,
          row: 80,
          col: 5,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
            },
          },
        },
        {
          value: '',
          row: 83,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              top: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 83,
            col: 8,
          },
        },
        {
          value: 'VALIDACIÓN',
          row: 86,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 86,
            col: 8,
          },
        },
        // FIRMA
        {
          value: 'POR LA COORDINACIÓN GENERAL DE INFRAESTRUCTURA, DESARROLLO URBANO Y ECOLOGÍA',
          row: 88,
          col: 1,
          estilo: {
            font: {
              size: 11,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'top',
              wrapText: true,
            },
          },
          combinar: {
            row: 88,
            col: 8,
          },
        },
        {
          value: 'REPRESENTANTE',
          row: 90,
          col: 1,
          estilo: {
            font: {
              size: 11,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 90,
            col: 8,
          },
        },
        {
          value: '',
          row: 93,
          col: 3,
          estilo: {
            font: {
              size: 11,
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 93,
            col: 6,
          },
        },
        {
          value: this.firma.funcionario?.nombre.toUpperCase(),
          row: 94,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 94,
            col: 7,
          },
        },
        {
          value: this.firma.funcionario?.puesto.toUpperCase(),
          row: 95,
          col: 2,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 95,
            col: 7,
          },
        },
        {
          value: 'ESTE DOCUMENTO SIMPLIFICADO SE EMPLEARÁ POR CAUSA DE EXCEPCIÓN, COMO FORMA RÁPIDA DE ACCEDER A LA AUTORIZACIÓN DE LOS RECURSOS DE INVERSIÓN, Y NO SUSTITUYE AL EXPEDIENTE TÉCNICO COMPLETO DE ACUERDO A LAS DISPOSICIONES DE LEY.',
          row: 104,
          col: 1,
          estilo: {
            font: {
              size: 8,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 105,
            col: 8,
          },
        },
      ];
    },
    crearDatosDocumentoCedula2() {
      const bordesProblematica = [];
      const bordesJustificacion = [];
      // i es la fila donde inicia a pintar los bordes
      for (let i = 12; i <= 25; i += 1) {
        bordesProblematica.push(
          {
            value: '',
            row: i,
            col: 1,
            estilo: {
              border: {
                left: {
                  style: 'thin',
                  color: '000000',
                },
              },
            },
          },
          {
            value: '',
            row: i,
            col: 9,
            estilo: {
              border: {
                right: {
                  style: 'thin',
                  color: '000000',
                },
              },
            },
          },
        );
      }
      for (let i = 33; i <= 46; i += 1) {
        bordesJustificacion.push(
          {
            value: '',
            row: i,
            col: 1,
            estilo: {
              border: {
                left: {
                  style: 'thin',
                  color: '000000',
                },
              },
            },
          },
          {
            value: '',
            row: i,
            col: 9,
            estilo: {
              border: {
                right: {
                  style: 'thin',
                  color: '000000',
                },
              },
            },
          },
        );
      }
      return [
        // INICIO INFORMACION ENCABEZADO DE PAGINA
        {
          value: `PROGRAMA DE INVERSIONES EJERCICIO ${this.getYearSolicitud}`,
          row: 2,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 2,
            col: 9,
          },
        },
        {
          value: 'EXPEDIENTE TÉCNICO SIMPLIFICADO',
          row: 3,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 3,
            col: 9,
          },
        },
        {
          value: 'ANEXO 2: INFORMACIÓN COMPLEMENTARIA',
          row: 4,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 4,
            col: 9,
          },
        },
        {
          value: 'DEPENDENCIA O ENTIDAD EJECUTORA',
          row: 7,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
          combinar: {
            row: 7,
            col: 3,
          },
        },
        {
          value: 'COORDINACIÓN GENERAL DE INFRAESTRUCTURA, DESARROLLO URBANO Y ECOLOGÍA',
          row: 7,
          col: 5,
          estilo: {
            font: {
              size: 9,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
          combinar: {
            row: 7,
            col: 9,
          },
        },
        {
          value: 'NOMBRE DE LA OBRA',
          row: 8,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: '1',
          row: 8,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: this.solicitudObra.meta,
          row: 8,
          col: 3,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 8,
            col: 9,
          },
        },
        {
          value: 'LOCALIDAD:',
          row: 9,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: this.solicitudObra.localidad,
          row: 9,
          col: 3,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 9,
            col: 5,
          },
        },
        {
          value: 'MUNICIPIO:',
          row: 9,
          col: 6,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: this.solicitudObra.municipio.nombre.toUpperCase(),
          row: 9,
          col: 7,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 9,
            col: 9,
          },
        },
        {
          value: 'PROBLEMÁTICA A RESOLVER ESPECIFICANDO SITUACIÓN ACTUAL Y PROGRAMADA:',
          row: 11,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              top: {
                style: 'thin',
                color: '000000',
              },
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 11,
            col: 9,
          },
        },
        // BORDES
        ...bordesProblematica,
        {
          value: '',
          row: 12,
          col: 1,
          estilo: {
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: '',
          row: 12,
          col: 9,
          estilo: {
            border: {
              right: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: this.solicitudObra.problematica,
          row: 13,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'distributed',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 23,
            col: 8,
          },
        },
        {
          value: '',
          row: 26,
          col: 1,
          estilo: {
            border: {
              top: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 26,
            col: 9,
          },
        },
        {
          value: 'METAS',
          row: 27,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 27,
            col: 9,
          },
        },
        {
          value: 'METAS PROGRAMADAS DE PROYECTO ( ha, m2, m3, etc.  ):_____________________________________________________',
          row: 28,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: `${this.solicitudObra.metaFisica} ${this.solicitudObra.unidadMetaFisica}`,
          row: 28,
          col: 6,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
          combinar: {
            row: 28,
            col: 7,
          },
        },
        {
          value: '',
          row: 28,
          col: 9,
          estilo: {
            border: {
              right: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: 'BENEFICIARIOS PROGRAMADOS (PERSONAS, PRODUCTORES, ALUMNOS, ETC.):____________________________________',
          row: 29,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: `${this.solicitudObra.beneficiariosCantidad} ${this.solicitudObra.beneficiariosTipo}`,
          row: 29,
          col: 6,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
          combinar: {
            row: 29,
            col: 7,
          },
        },
        {
          value: '',
          row: 29,
          col: 9,
          estilo: {
            border: {
              right: {
                style: 'thin',
                color: '000000',
              },
            },
          },
        },
        {
          value: '',
          row: 30,
          col: 1,
          estilo: {
            border: {
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 30,
            col: 9,
          },
        },
        {
          value: 'JUSTIFICACIÓN TECNICA Y SOCIAL:',
          row: 32,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
            border: {
              top: {
                style: 'thin',
                color: '000000',
              },
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 32,
            col: 9,
          },
        },
        ...bordesJustificacion,
        {
          value: '',
          row: 47,
          col: 1,
          estilo: {
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
              left: {
                style: 'thin',
                color: '000000',
              },
              right: {
                style: 'thin',
                color: '000000',
              },
            },
          },
          combinar: {
            row: 47,
            col: 9,
          },
        },
        {
          //  Verificar justifiaciones en excel se maneja juntas y en sistema separadas
          value: this.solicitudObra.justificacionTecnica,
          row: 34,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'distributed',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 44,
            col: 8,
          },
        },
      ];
    },
    crearDatosDocumentoUbicacion() {
      return [
        // INICIO INFORMACION ENCABEZADO DE PAGINA
        {
          value: `PROGRAMA DE INVERSIONES EJERCICIO ${this.getYearSolicitud}`,
          row: 2,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 2,
            col: 9,
          },
        },
        {
          value: 'EXPEDIENTE TÉCNICO SIMPLIFICADO',
          row: 3,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 3,
            col: 9,
          },
        },
        {
          value: 'ANEXO 4: LOCALIZACIÓN DE LA OBRA.',
          row: 4,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 4,
            col: 9,
          },
        },
        {
          value: 'DEPENDENCIA O ENTIDAD EJECUTORA',
          row: 6,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
          combinar: {
            row: 6,
            col: 3,
          },
        },
        {
          value: 'COORDINACIÓN GENERAL DE INFRAESTRUCTURA, DESARROLLO URBANO Y ECOLOGÍA',
          row: 6,
          col: 5,
          estilo: {
            font: {
              size: 9,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
          combinar: {
            row: 6,
            col: 9,
          },
        },
        {
          value: 'NOMBRE DE LA OBRA',
          row: 7,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: '1',
          row: 7,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: this.solicitudObra.meta,
          row: 7,
          col: 3,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 7,
            col: 9,
          },
        },
        {
          value: 'LOCALIDAD:',
          row: 8,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: this.solicitudObra.localidad,
          row: 8,
          col: 3,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 8,
            col: 5,
          },
        },
        {
          value: 'MUNICIPIO:',
          row: 8,
          col: 6,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: this.solicitudObra.municipio.nombre,
          row: 8,
          col: 7,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 8,
            col: 9,
          },
        },
        {
          value: 'MACROLOCALIZACIÓN (UBICACIÓN GEOGRÁFICA)',
          row: 10,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
          },
          combinar: {
            row: 10,
            col: 9,
          },
        },
        {
          value: 'imagen macrolocalizacion',
          row: 11,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 38,
            col: 9,
          },
        },
        {
          value: 'MICROLOCALIZACIÓN (UBICACIÓN EN LA CD. O POBLADO)',
          row: 39,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            ...this.estilos.todosLosBordesThin,
          },
          combinar: {
            row: 39,
            col: 9,
          },
        },
        {
          value: 'imagen microlocalizacion',
          row: 40,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 67,
            col: 9,
          },
        },
      ];
    },
    crearDatosDocumentoCuestionario() {
      let rowPreguntas = 10;
      const preguntasConRespuesta = [];
      const preguntasCuestionario = [
        {
          texto: '1.-¿ LA OBRA FORMA PARTE DE LOS OBJETIVOS, ESTRATEGIAS Y PRIORIDADES QUE A CORTO, MEDIANO Y LARGO PLAZO CONTEMPLA EL PLAN DE DESARROLLO ?',
          requiereRespuesta: true,
        },
        {
          texto: 'SI LA RESPUESTA ES NO, SE DEBERÁ ANEXAR AL EXPEDIENTE TÉCNICO SIMPLIFICADO, LA JUSTIFICACIÓN CORRESPONDIENTE PARA SU ANÁLISIS Y EN CASO DE SER PROCEDENTE SU VALIDACIÓN.',
          requiereRespuesta: false,
        },
        {
          texto: '2.- ¿SE CUMPLE CON LAS DISPOSICIONES QUE PARA LA PLANEACIÓN Y EJECUCIÓN DE OBRA PUBLICA, SE ENCUENTRAN CONTENIDAS EN EL REGLAMENTO DE CONTRUCCIÓN DE LA CIUDAD DE HERMOSILLO, LEY GENERAL DE EQUILIBRIO ECOLÓGICO Y PROTECCIÓN AL AMBIENTE DEL ESTADO DE SONORA, REGLAMENTO PARA EL MANEJO Y DISPOSICIÓN DE BIENES MUEBLES E INMUEBLES DEL H. AYUNTAMIENTO DE HERMOSILLO, LEY GENERAL DE DESARROLLO FORESTAL SUSTENTABLE, LEY GENERAL DE ASENTAMIENTOS HUMANOS, ORDENAMIENTO TERRITORIAL Y DESARROLLO URBANO, LEY GENERAL DE DESARROLLO SOCIAL Y LAS NORMAS OFICIALES MEXICANAS DE CONTROL DE CALIDAD Y DEMÁS DISPOSICIONES LEGALES Y REGLAMENTACIÓN APLICABLE?',
          requiereRespuesta: true,
        },
        {
          texto: '3.- ¿SE CUENTA CON LOS ESTUDIOS Y PROYECTOS, ESPECIFICACIONES DE CONSTRUCCIÓN, NORMAS DE CALIDAD Y EL PROGRAMA DE EJECUCIÓN TOTALMENTE TERMINADOS Y DISPOSICIÓN PARA SU CONSULTA?',
          requiereRespuesta: true,
        },
        {
          texto: '4.- ¿EL PROYECTO EJECUTIVO DE LA OBRA  SE ENCUENTRA REGISTRADO EN FORMATO DIGITAL EN LOS ARCHIVOS  CON LOS QUE PARA EL CASO, DEBE CONTAR LA DEPENDENCIA Y A DISPOSICIÓN PARA SU CONSULTA?',
          requiereRespuesta: true,
        },
        {
          texto: '5.- ¿CUENTA CON LOS PERMISOS Y AUTORIZACIONES, CON LA DISPONIBILIDAD DE LOS TERRENOS Y CON LA LIBERACIÓN DE DERECHOS DE VÍA PARA LLEVAR A CABO LA CONSTRUCCIÓN DE LA OBRA?',
          requiereRespuesta: true,
        },
      ];
      preguntasCuestionario.forEach((pregunta) => {
        preguntasConRespuesta.push(
          {
            value: pregunta.texto,
            row: rowPreguntas,
            col: 1,
            estilo: {
              font: {
                size: 11,
              },
              alignment: {
                horizontal: 'justify',
                vertical: 'center',
                wrapText: true,
              },
            },
            combinar: {
              row: rowPreguntas,
              col: 9,
            },
          },
        );
        if (pregunta.requiereRespuesta) {
          preguntasConRespuesta.push(
            {
              value: 'RESPUESTA     SI (  X  )              NO (   )',
              row: rowPreguntas + 2,
              col: 2,
              estilo: {
                font: {
                  size: 11,
                },
                alignment: {
                  horizontal: 'left',
                  vertical: 'center',
                  wrapText: true,
                },
              },
              combinar: {
                row: rowPreguntas + 2,
                col: 9,
              },
            },
          );
          rowPreguntas += 4;
        } else {
          rowPreguntas += 2;
        }
      });
      return [
        // INICIO INFORMACION ENCABEZADO DE PAGINA
        {
          value: 'DIRECCIÓN DE ESTUDIOS FINANCIEROS Y APOYOS ADMINISTRATIVOS',
          row: 2,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 2,
            col: 9,
          },
        },
        {
          value: 'FICHA TÉCNICA (CUESTIONARIO TÉCNICO DE LA OBRA)',
          row: 3,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 3,
            col: 9,
          },
        },
        {
          value: this.solicitudObra.fuenteFinanciera?.nombre,
          row: 4,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 4,
            col: 9,
          },
        },
        {
          value: 'DEPENDENCIA O ENTIDAD EJECUTORA',
          row: 7,
          col: 1,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
          combinar: {
            row: 7,
            col: 3,
          },
        },
        {
          value: 'COORDINACIÓN GENERAL DE INFRAESTRUCTURA, DESARROLLO URBANO Y ECOLOGÍA',
          row: 7,
          col: 5,
          estilo: {
            font: {
              size: 9,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
          combinar: {
            row: 7,
            col: 9,
          },
        },
        {
          value: 'NOMBRE DE LA OBRA',
          row: 8,
          col: 1,
          estilo: {
            font: {
              size: 10,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: '1',
          row: 8,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: this.solicitudObra.meta,
          row: 8,
          col: 3,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 8,
            col: 9,
          },
        },
        // INICIO PREGUNTAS
        ...preguntasConRespuesta,
        // FIN PREGUNTAS
        // FIRMA
        {
          value: 'POR LA COORDINACIÓN GENERAL DE INFRAESTRUCTURA, DESARROLLO URBANO Y ECOLOGÍA',
          row: 33,
          col: 1,
          estilo: {
            font: {
              size: 11,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'top',
              wrapText: true,
            },
          },
          combinar: {
            row: 33,
            col: 9,
          },
        },
        {
          value: 'REPRESENTANTE',
          row: 34,
          col: 2,
          estilo: {
            font: {
              size: 11,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 34,
            col: 8,
          },
        },
        {
          value: '',
          row: 37,
          col: 3,
          estilo: {
            font: {
              size: 11,
            },
            border: {
              bottom: {
                style: 'thin',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 37,
            col: 7,
          },
        },
        {
          value: this.firma.funcionario?.nombre.toUpperCase(),
          row: 38,
          col: 2,
          estilo: {
            font: {
              size: 10,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 38,
            col: 8,
          },
        },
        {
          value: this.firma.funcionario?.puesto.toUpperCase(),
          row: 39,
          col: 2,
          estilo: {
            font: {
              size: 8,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 39,
            col: 8,
          },
        },

      ];
    },

    getHeaders() {
      const headers = this.headersColumnas
        .map((header) => header.value);
      return headers;
    },
    getColumnas() {
      const columnas = this.headersColumnas
        .map((columna) => columna.nombreColumna);
      return columnas;
    },

  },
};
</script>
<style lang="scss"></style>
